import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=233f65c6&scoped=true&"
import script from "./Undo.vue?vue&type=script&lang=js&"
export * from "./Undo.vue?vue&type=script&lang=js&"
import style0 from "./Undo.vue?vue&type=style&index=0&id=233f65c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f65c6",
  null
  
)

export default component.exports